// extracted by mini-css-extract-plugin
export var deleteModal = "_g5-0";